<template>
  <div>
    <div class="shipment">
      <div class="shipment-details">
        <div class="shipment-head">
          <span>{{ $t("shipment_details") }}</span>
          <span class="cursor-pointer" @click="$emit('goToStep', 1)">
            <IconEdit />
          </span>
        </div>
        <div class="shipment-body">
          <div class="details">
            <span>Shipment Type</span>
            <span style="text-transform: capitalize"
              >{{ shipmentDetails.shipmentType }}
            </span>
          </div>
          <!-- <div class="details">
            <span>Shipment Partner</span>
            <span>{{ shipmentDetails.partner }} </span>
          </div> -->
          <div class="details" v-if="shipmentDetails.flightNumber">
            <span>Flight Number</span>
            <span>{{ shipmentDetails.flightNumber }} </span>
          </div>
          <div class="details">
            <span>Reference Number </span>
            <span>{{ shipmentDetails.reference }} </span>
          </div>
          <div class="details">
            <span>Loading Date</span>
            <span>{{ shipmentDetails.loadingDate }} </span>
          </div>

          <div class="details">
            <span>ETA</span>
            <span>{{ shipmentDetails.eta }} </span>
          </div>
          <div class="details" v-if="shipmentDetails.waybillNo">
            <span>Air Waybill Number</span>
            <span>{{ shipmentDetails.waybillNo }} </span>
          </div>
          <div class="details">
            <span>Departure Date</span>
            <span>{{ shipmentDetails.departureDate }} </span>
          </div>
          <div class="details" v-if="shipmentDetails.vesselName">
            <span>Vessel Name </span>
            <span>{{ shipmentDetails.vesselName }} </span>
          </div>
          <div class="details">
            <span>Point of Arrival </span>
            <span>{{ shipmentDetails.pointOfArrival }}</span>
          </div>
          <div class="details" v-if="shipmentDetails.pointOfDischarge">
            <span>Point of Discharge </span>
            <span>{{ shipmentDetails.pointOfDischarge }} </span>
          </div>
        </div>
      </div>

      <div class="shipment__right">
        <div>
          <div class="shipment-head">
            <span>{{ $t("orign") }}</span>

            <span class="cursor-pointer" @click="$emit('goToStep', 3)">
              <IconEdit />
            </span>
          </div>
          <div class="origin-body">
            <div class="origin-body-left">
              <div class="details">
                <span>Name</span>
                <span>{{ origin.name }} </span>
              </div>
              <div class="details" v-if="origin.personOfContact">
                <span>Phone Number</span>
                <span>{{ origin.personOfContact }} </span>
              </div>
              <div class="details">
                <span>Country</span>
                <span>{{ origin.country }} </span>
              </div>
            </div>
            <div class="origin-body-right">
              <div class="details">
                <span>State/Province </span>
                <span>{{ origin.region || "" }}</span>
              </div>
              <div class="details" v-if="origin.county">
                <span>LGA/Country</span>
                <span>{{ origin.county }} </span>
              </div>
              <div class="details">
                <span>Address</span>
                <span>{{
                  (origin.address && origin.address.name) || origin.name
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="shipment-head">
            <span>{{ $t("destination") }}</span>

            <span class="cursor-pointer" @click="$emit('goToStep', 3)">
              <IconEdit />
            </span>
          </div>
          <div class="origin-body">
            <div class="origin-body-left">
              <div class="details">
                <span>Name</span>
                <span>{{ destination.name }} </span>
              </div>
              <div class="details" v-if="destination.personOfContact">
                <span>Phone Number</span>
                <span>{{ destination.personOfContact }} </span>
              </div>
              <div class="details">
                <span>Country</span>
                <span>{{ destination.country }} </span>
              </div>
            </div>
            <div class="origin-body-right">
              <div class="details">
                <span>State/Province </span>
                <span>{{ destination.region || "" }}</span>
              </div>
              <div class="details" v-if="destination.county">
                <span>LGA/Country</span>
                <span>{{ destination.county }} </span>
              </div>
              <div class="details">
                <span>Address</span>
                <span>
                  <span>{{
                    (destination.address && destination.address.name) ||
                    destination.name
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <div style="height: 140px">
            <map-direction
              class="card-body h-100"
              :start="originLatLng"
              :end="destinationLatLng"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card-body mt-3 mb-3 box-shadow-1" style="border-radius: 8px">
      <div class="table-responsive">
        <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
          <div class="row">
            <div class="col-sm-12">
              <p class="mb-3">{{ $t("container_details") }}</p>

              <table class="table">
                <thead class="data-table-bg">
                  <tr>
                    <th>{{ $t("product") }}</th>
                    <th>{{ $t("no-of-pallet") }}</th>
                    <th>{{ $t("container_number") }}</th>
                    <th>{{ $t("no-of-devices") }}</th>
                    <th>{{ $t("actions") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="index"
                    v-for="(container, index) in containers"
                    class="container-details"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                  >
                    <td>{{ container.product }}</td>
                    <td>{{ container.pallet }}</td>
                    <td>{{ container.containerNumber }}</td>
                    <td>{{ container.assignedDevices.length }}</td>
                    <td style="display: flex; align-items: center; gap: 0.5rem">
                      <span
                        class="cursor-pointer"
                        @click="$emit('goToStep', 2)"
                      >
                        <IconEdit />
                      </span>
                      <span
                        v-if="containers.length > 1"
                        class="cursor-pointer"
                        @click="$emit('delete_containerDetails', index)"
                      >
                        <IconDeleteUser />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconEdit from "../../../components/Iconsvg/IconEditUser.vue";
import IconDeleteUser from "../../../components/Iconsvg/IconDeleteUser.vue";

import MapDirection from "./MapDirection.vue";

export default {
  components: {
    IconEdit,
    MapDirection,
    IconDeleteUser,
  },
  name: "Summary",
  props: {
    origin: {
      type: Object,
      default: () => ({}),
    },
    destination: {
      type: Object,
      default: () => ({}),
    },
    shipmentDetails: {
      type: Object,
      default: () => ({}),
    },
    containers: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    console.log(
      "Initial shipmentDeets:",
      this.shipmentDetails,
      this.destination,
      this.origin
    );
  },
  computed: {
    originLatLng() {
      if (this.origin.address) {
        const { lat, lng } = this.origin.address;
        return { lat, lng };
      } else {
        const { lat, lng } = this.shipmentDetails;
        return lat && lng ? { lat, lng } : null;
      }
    },
    destinationLatLng() {
      if (this.destination.address) {
        const { lat, lng } = this.destination.address;
        return { lat, lng };
      } else {
        const { lat, lng } = this.shipmentDetails;
        return lat && lng ? { lat, lng } : null;
      }
    },
  },
  methods: {
    isValidLatLng(lat, lng) {
      return (
        typeof lat === "number" &&
        typeof lng === "number" &&
        !isNaN(lat) &&
        !isNaN(lng)
      );
    },
  },
};
</script>

<style scoped>
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  background-color: transparent;
}

.data-table-bg {
  background-color: #f8f9fa;
}

.cursor-pointer {
  cursor: pointer;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.col-gap-1 {
  gap: 1rem;
}

.row {
  margin-left: 0;
}
.shipment {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}
.shipment-details {
  flex-basis: 32.5%;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0px 2.96px 60px 0px #a3abb91a;
}
.shipment-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  margin-bottom: 16px;
}
.shipment-head span {
  color: #213e7a;
  font-size: 18px;
}
.shipment__right {
  flex: 1;
}
.details {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  padding-block: 16px;
  gap: 10px;
}
.details:not(:last-child) {
  border-bottom: 0.7px solid #b7c3cd;
}
.details span:first-child {
  color: #5e6a79;
  font-weight: 400;
}
.details span:last-child {
  color: #404a57;
  font-weight: 500;
}

.shipment__right {
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0px 2.96px 60px 0px #a3abb91a;
}

.origin-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  justify-content: space-between;
}
</style>
